/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './vaccination.reducer';

export const VaccinationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const vaccinationEntity = useAppSelector(state => state.vaccination.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="vaccinationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.vaccination.detail.title">Vaccination</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.vaccination.id">Id</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.vaccination.active">Active</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.vaccination.code">Code</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.code}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.vaccination.description">Description</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.description}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.vaccination.name">Name</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.name}</dd>
          <dt>
            <span id="protection">
              <Translate contentKey="tinyMedicRestApp.vaccination.protection">Protection</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.protection}</dd>
          <dt>
            <span id="route">
              <Translate contentKey="tinyMedicRestApp.vaccination.route">Route</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.route}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.vaccination.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.vaccination.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.vaccination.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.vaccination.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{vaccinationEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/vaccination" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/vaccination/${vaccinationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default VaccinationDetail;
